import script from "./ShiftTcpaDisclaimerCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./ShiftTcpaDisclaimerCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./ShiftTcpaDisclaimerCheckbox.vue?vue&type=style&index=0&id=d53927b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d53927b0"]])

export default __exports__